import React, { useContext, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Navigate, Route, Routes } from 'react-router-dom';
import { Context as StoreContext } from '../../../providers/StoreContextProvider';
import { triggerNotification } from '../../../helpers/notification';
import StoreTaxSettingsView from './StoreTaxSettingsView';
import StoreTaxEditView from './StoreTaxEditView';

const StoreTaxesViews = ({ ecomStore }) => {
  const { fetchStoreTax, fetchStoreProductOptions } = useContext(StoreContext);

  useEffect(() => {
    if (ecomStore) {
      fetchStoreTax(ecomStore.pkEcomStore, null, (e) => triggerNotification(e));
      fetchStoreProductOptions(ecomStore.pkEcomStore, {});
    }
  }, [ecomStore]);

  return (
    <Routes>
      <Route
        element={<StoreTaxEditView ecomStore={ecomStore} />}
        path="/create"
      />
      <Route
        element={<StoreTaxEditView duplicate ecomStore={ecomStore} />}
        path="/:pkEcomStoreTax/duplicate"
      />
      <Route
        element={<StoreTaxEditView ecomStore={ecomStore} />}
        path="/:pkEcomStoreTax"
      />
      <Route
        element={<StoreTaxSettingsView ecomStore={ecomStore} />}
        path="/"
      />
      <Route
        element={<Navigate replace to="/merchant/settings/taxes" />}
        path="*"
      />
    </Routes>
  );
};

StoreTaxesViews.propTypes = {
  ecomStore: PropTypes.object,
  loading: PropTypes.bool
};

export default StoreTaxesViews;
